"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const utils_1 = require("./utils");
const serializeLocation_1 = tslib_1.__importDefault(require("./utils/serializeLocation"));
const serializeMemoryInfo_1 = tslib_1.__importDefault(require("./utils/serializeMemoryInfo"));
const serializePerformanceEntry_1 = tslib_1.__importDefault(require("./utils/serializePerformanceEntry"));
const serializeRequest_1 = tslib_1.__importDefault(require("./utils/serializeRequest"));
const serializeResponse_1 = tslib_1.__importDefault(require("./utils/serializeResponse"));
const serializeEndpointInfo = (response) => {
    const url = new URL(response.url);
    const [service] = url.pathname.split("/").filter(Boolean);
    return {
        service: service || null,
        ...["origin", "pathname"].reduce((obj, key) => {
            return { ...obj, [key]: url[key] };
        }, {}),
    };
};
const getDebugInfo = (location = window.location, performance = window.performance) => {
    return {
        ...(0, utils_1.flatten)((0, serializeMemoryInfo_1.default)(performance.memory), { prefix: "memory" }),
        ...(0, utils_1.flatten)((0, serializeLocation_1.default)(location), { prefix: "location" }),
    };
};
const logException = (logger) => (error) => {
    logger?.logException(error, { component: __filename, ...getDebugInfo() });
};
const logPerformance = (logger) => (entry) => {
    logger.logDebug("PerformanceResource", { component: __filename, ...(0, serializePerformanceEntry_1.default)(entry) });
};
const logUnhandledRejection = (logger) => (event) => {
    logger.logError("unhandledrejection", {
        component: __filename,
        message: event.reason?.message,
        stacktrace: event.reason?.stack,
        ...getDebugInfo(),
    });
};
function setupLogging(logger) {
    window.addEventListener("error", logException(logger));
    window.addEventListener("unhandledrejection", logUnhandledRejection(logger));
    if ("PerformanceObserver" in window) {
        const observer = new PerformanceObserver((entryList) => {
            const entries = entryList.getEntries();
            entries.forEach((entry) => logPerformance(logger)(entry));
        });
        observer.observe({ entryTypes: ["resource"] });
    }
    if (window && "fetch" in window) {
        window.fetch = new Proxy(fetch, {
            apply: (target, thisArg, args) => {
                let clonedRequest = null;
                if (args[0] instanceof Request) {
                    clonedRequest = args[0].clone();
                    logger.logDebug("RequestStart", (0, utils_1.flatten)((0, serializeRequest_1.default)(clonedRequest), { prefix: "request" }));
                }
                // @ts-ignore "A spread argument must either have a tuple type or be passed to a rest parameter.ts(2556)"
                return target(...args).then((response) => {
                    const clonedResponse = response.clone();
                    // do !!NOT!! parse the body of the response here as it will break the app
                    if ([200, 201, 401, 403, 412].indexOf(response.status) === -1) {
                        logger.logError("RequestUnsuccessful", {
                            ...(clonedRequest ? (0, utils_1.flatten)((0, serializeRequest_1.default)(clonedRequest), { prefix: "request" }) : {}),
                            ...(0, utils_1.flatten)((0, serializeResponse_1.default)(clonedResponse), { prefix: "response" }),
                            ...getDebugInfo(),
                            ...(0, utils_1.flatten)(serializeEndpointInfo(clonedResponse), { prefix: "endpoint" }),
                        });
                    }
                    else {
                        logger.logDebug("RequestEnd", {
                            ...(0, utils_1.flatten)((0, serializeResponse_1.default)(clonedResponse), { prefix: "response" }),
                            ...getDebugInfo(),
                            ...(0, utils_1.flatten)(serializeEndpointInfo(clonedResponse), { prefix: "endpoint" }),
                        });
                    }
                    return response;
                }, (ex) => {
                    logException(logger)(ex);
                    throw ex;
                });
            },
        });
    }
}
exports.default = setupLogging;
